// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modebar-btn .icon{margin-top:-12px;width:15px !important}`, "",{"version":3,"sources":["webpack://./src/assets/scss/modebar.scss"],"names":[],"mappings":"AAAA,mBACI,gBAAA,CACA,qBAAA","sourcesContent":[".modebar-btn .icon {\n    margin-top: -12px;\n    width: 15px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
